import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useGame } from "../context/GameContext";
import PageLayout from "../components/PageLayout";
import MdGlowButton from "../components/MdGlowButton";
import { KeyRound, CheckCircle } from "lucide-react";

const normalizeCode = (raw) => String(raw || "").replace(/\s+/g, "").toUpperCase();

const CodeLogin = () => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { saveToken } = useGame();

  const submit = async (e) => {
    e.preventDefault();
    const normalized = normalizeCode(code);
    if (!normalized) {
      toast.error("Entrez votre code d'accès");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/code", { code: normalized });
      saveToken(data.token, data.code);
      toast.success("Code validé");
      navigate("/welcome");
    } catch (err) {
      if (!err?.response) {
        toast.error("Impossible de joindre le serveur. Vérifiez que l'API est déployée.");
        return;
      }
      toast.error(err?.response?.data?.detail || "Code invalide");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageLayout title="Casting Le Maillon Faible">
      <div className="text-center mb-8 fade-up">
        <h2 className="text-3xl sm:text-4xl font-black text-white leading-tight mb-4">
          Et si on jouait comme <span className="text-md-cyan">à la télé ?</span>
        </h2>
        <p className="text-white/60 leading-relaxed max-w-md mx-auto">
          Bienvenue dans la suite du casting du Maillon Faible. Entrez votre code confidentiel pour
          démarrer votre session. Attention, votre code est à usage unique.
        </p>
      </div>

      <form onSubmit={submit} className="md-card p-6 sm:p-8" data-testid="code-login-form">
        <div className="text-center mb-6">
          <div className="w-10 h-10 rounded-full bg-md-electric/15 border-2 border-md-cyan/40 flex items-center justify-center mx-auto mb-3">
            <KeyRound className="text-md-cyan" size={20} />
          </div>
          <div className="text-xs uppercase tracking-[0.25em] text-white/45">Accès candidat</div>
        </div>

        <label className="block text-sm font-medium text-md-silver/80 tracking-wide mb-2 text-center">
          Votre code d&apos;accès
        </label>
        <input
          type="text"
          value={code}
          onChange={(e) => setCode(normalizeCode(e.target.value))}
          placeholder=""
          maxLength={16}
          autoComplete="off"
          className="md-input text-xl sm:text-2xl tracking-[0.35em] text-center font-semibold"
          data-testid="code-input"
          autoFocus
        />

        <MdGlowButton type="submit" disabled={loading} wrapClassName="mt-0" data-testid="code-submit-button">
          {loading ? (
            "Vérification..."
          ) : (
            <>
              <CheckCircle className="w-5 h-5 shrink-0" />
              Entrer dans le studio
            </>
          )}
        </MdGlowButton>
      </form>
    </PageLayout>
  );
};

export default CodeLogin;
